export const convertToPercentage = (value: number, precision = 0): string => {
  return Math.floor(value * 100).toFixed(precision);
};

export const convertWithoutFloorToPercentage = (value: number, precision = 0): string => {
  return (value * 100).toFixed(precision);
};
